import React, { useMemo } from 'react'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import { Breadcrumb } from 'react-bootstrap'
// import Link from 'next/link'

import styles from './style.module.scss'
import CustomLink from '../customLink'
import { ONE_TURF_BASE_URL } from '@shared-submodule/sm-constants'

const BreadcrumbNav = ({ isArticle, listicleCurrentPage = 1, dynamicName, checkExternalRoutes = false }) => {
  const valuesToIgnore = useMemo(() => ['cricket'], [])
  const router = useRouter()
  let nav = router?.asPath
    ?.replace(/\?.+/, '')
    ?.split('/')
    ?.filter(x => x)
  nav = listicleCurrentPage === 1 ? nav : nav.slice(0, -1)

  function getSlug(to, value, index, nav) {
    if (value === 'author') {
      return `${to}${value}s`
    } else return `${to}${value}`
  }
  function externalRoutes(value) {
    const routes = []
    return routes.includes(value)
  }
  return (
    <Breadcrumb className={`${styles.breadcrumb} text-capitalize`}>
      {/* <Breadcrumb.Item linkAs={Link} href="/" className={`${styles.item} mb-1`}> */}
      <li className={`${styles.item} mb-1`}>
        <CustomLink href="/" prefetch={false}>
          <a>Home</a>
        </CustomLink>
      </li>
      {/* </Breadcrumb.Item> */}
      {nav.length !== 0 &&
        nav.map((value = '-', index) => {
          if (valuesToIgnore.includes(value)) return null
          const isLast = index === nav?.length - 1
          const to = router?.asPath?.split(value)[0]
          if (dynamicName) {
            if (nav?.length === 3 && isLast) {
              return (
                <Breadcrumb.Item key={value} className={`${styles.item} ${styles.active} mb-1`} active>
                  {dynamicName}
                </Breadcrumb.Item>
              )
            }
            if (nav.length > 3 && index === 2) {
              return (
                <li key={value} className={`${styles.item} mb-1`}>
                  <CustomLink href={getSlug(to, value, index, nav)} prefetch={false}>
                    {dynamicName}
                  </CustomLink>
                </li>
              )
            }
          }
          if (isLast) {
            if (!isArticle) {
              return (
                <Breadcrumb.Item key={value} className={`${styles.item} ${styles.active} mb-1`} active>
                  {value === 'wwe' ? 'WWE' : value?.replace(/-/gi, ' ')}
                </Breadcrumb.Item>
              )
            } else {
              return null
            }
          } else {
            return (
              <li key={value} className={`${styles.item} mb-1`}>
                {/* <CustomLink href={value === 'author' ? `${to + value}s` : to + value} prefetch={false}> */}
                {externalRoutes(value) && checkExternalRoutes ? (
                  <a href={`${ONE_TURF_BASE_URL}${getSlug(to, value, index, nav)}`}>{value.replace(/-/gi, ' ')}</a>
                ) : (
                  <CustomLink href={getSlug(to, value, index, nav)} prefetch={false}>
                    <a>{value.replace(/-/gi, ' ')}</a>
                  </CustomLink>
                )}
              </li>
            )
          }
        })}
    </Breadcrumb>
  )
}

BreadcrumbNav.propTypes = {
  isArticle: PropTypes.bool,
  checkExternalRoutes: PropTypes.bool,
  listicleCurrentPage: PropTypes.number,
  dynamicName: PropTypes.string
}

export default BreadcrumbNav
